import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import { CheckCircle2, AlertCircle, Loader2 } from 'lucide-react';

const Success = () => {
  const { ticketNumber } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [entry, setEntry] = useState<any>(null);
  const [campaign, setCampaign] = useState<any>(null);

  useEffect(() => {
    if (!ticketNumber) {
      setError('Invalid ticket number');
      setLoading(false);
      return;
    }
    fetchEntryDetails();
  }, [ticketNumber]);

  const fetchEntryDetails = async () => {
    try {
      const { data: entryData, error: entryError } = await supabase
        .from('entries')
        .select('*, campaigns(*)')
        .eq('ticket_number', ticketNumber)
        .single();

      if (entryError) throw entryError;

      if (!entryData) {
        throw new Error('Entry not found');
      }

      if (entryData.payment_status !== 'completed') {
        throw new Error('Payment not completed');
      }

      setEntry(entryData);
      setCampaign(entryData.campaigns);
    } catch (error: any) {
      console.error('Error:', error);
      setError(error.message || 'Failed to fetch entry details');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="max-w-md mx-auto bg-white rounded-xl shadow-lg p-8 text-center">
        <Loader2 className="h-8 w-8 animate-spin mx-auto mb-4 text-purple-600" />
        <p>Loading confirmation...</p>
      </div>
    );
  }

  if (error || !entry || !campaign) {
    return (
      <div className="max-w-md mx-auto bg-white rounded-xl shadow-lg p-8">
        <div className="flex items-center justify-center text-red-600 mb-4">
          <AlertCircle className="h-12 w-12" />
        </div>
        <h2 className="text-2xl font-bold text-gray-800 text-center mb-4">Error</h2>
        <p className="text-gray-600 text-center mb-6">{error}</p>
        <button
          onClick={() => navigate('/')}
          className="w-full bg-purple-600 text-white py-2 px-4 rounded-md hover:bg-purple-700 transition-colors"
        >
          Return Home
        </button>
      </div>
    );
  }

  return (
    <div className="max-w-md mx-auto bg-white rounded-xl shadow-lg p-8">
      <div className="flex items-center justify-center text-green-600 mb-4">
        <CheckCircle2 className="h-12 w-12" />
      </div>
      <h2 className="text-2xl font-bold text-gray-800 text-center mb-6">Payment Successful!</h2>
      
      <div className="bg-gray-50 p-4 rounded-lg mb-6">
        <div className="flex justify-between items-center mb-2">
          <span className="text-gray-600">Ticket Number:</span>
          <span className="font-semibold">{entry.ticket_number}</span>
        </div>
        <div className="flex justify-between items-center mb-2">
          <span className="text-gray-600">Campaign:</span>
          <span className="font-semibold">{campaign.name}</span>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-gray-600">Amount Paid:</span>
          <span className="font-semibold">${campaign.ticket_price.toFixed(2)}</span>
        </div>
      </div>

      <p className="text-gray-600 text-center mb-6">
        Thank you for your purchase! You will receive a confirmation email shortly.
      </p>

      <button
        onClick={() => navigate('/')}
        className="w-full bg-purple-600 text-white py-2 px-4 rounded-md hover:bg-purple-700 transition-colors"
      >
        Return Home
      </button>
    </div>
  );
};

export default Success; 